<template>
  <nav class="container mx-auto px-4 py-6">
    <div class="flex items-center justify-between">
      <!-- Logo -->
      <router-link to="/" class="flex items-center gap-3 hover:opacity-80 transition-opacity">
        <div class="w-10 h-10 bg-gradient-to-br from-psychology-primary to-psychology-secondary rounded-lg flex items-center justify-center shadow-lg">
          <span class="text-2xl">🎯</span>
        </div>
        <div>
          <h1 class="font-bold text-lg bg-gradient-to-r from-psychology-primary to-psychology-secondary bg-clip-text text-transparent">Holland Test</h1>
          <p class="text-xs text-gray-500">霍兰德职业兴趣测试</p>
        </div>
      </router-link>

      <!-- 移动端菜单按钮 -->
      <div class="md:hidden">
        <button @click="toggleMenu" class="p-2 hover:bg-gray-100 rounded-md transition-colors">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="w-5 h-5">
            <line x1="4" x2="20" y1="12" y2="12"></line>
            <line x1="4" x2="20" y1="6" y2="6"></line>
            <line x1="4" x2="20" y1="18" y2="18"></line>
          </svg>
        </button>
      </div>

      <!-- 桌面端导航 -->
      <div class="hidden md:flex items-center gap-2">
        <router-link
          to="/guide"
          class="flex items-center gap-2 px-4 py-2 hover:bg-psychology-primary-10 rounded-lg transition-colors text-gray-700 hover:text-psychology-primary"
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M12 7v14"></path>
            <path d="M3 18a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h5a4 4 0 0 1 4 4 4 4 0 0 1 4-4h5a1 1 0 0 1 1 1v13a1 1 0 0 1-1 1h-6a3 3 0 0 0-3 3 3 3 0 0 0-3-3z"></path>
          </svg>
          <span class="text-sm font-medium">使用指南</span>
        </router-link>
        
        <router-link
          to="/history"
          class="flex items-center gap-2 px-4 py-2 hover:bg-psychology-primary-10 rounded-lg transition-colors text-gray-700 hover:text-psychology-primary"
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8"></path>
            <path d="M3 3v5h5"></path>
            <path d="M12 7v5l4 2"></path>
          </svg>
          <span class="text-sm font-medium">历史记录</span>
        </router-link>

        <a
          href="https://xhslink.com/m/4I3V4f0hZLb"
          target="_blank"
          rel="noopener noreferrer"
          class="flex items-center px-4 py-2 hover:bg-psychology-success-10 rounded-lg transition-colors text-gray-700 hover:text-psychology-success"
          title="小红书主页"
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M16 8.2A2.22 2.22 0 0 0 13.8 6c-.8 0-1.4.3-1.8.9-.4-.6-1-.9-1.8-.9A2.22 2.22 0 0 0 8 8.2c0 .6.3 1.2.7 1.6A226.652 226.652 0 0 0 12 13a404 404 0 0 0 3.3-3.1 2.413 2.413 0 0 0 .7-1.7"></path>
            <path d="M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H19a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H6.5a1 1 0 0 1 0-5H20"></path>
          </svg>
        </a>

        <!-- 开始测试按钮 -->
        <router-link
          to="/assessment/start"
          class="ml-2 px-5 py-2 bg-gradient-to-r from-psychology-primary to-psychology-secondary text-white rounded-lg font-medium hover:shadow-lg transition-all flex items-center gap-2"
        >
          <span>开始测试</span>
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M5 12h14"></path>
            <path d="m12 5 7 7-7 7"></path>
          </svg>
        </router-link>
      </div>
    </div>

    <!-- 移动端菜单 -->
    <div v-if="isMenuOpen" class="md:hidden mt-4 pb-4 border-t pt-4">
      <div class="flex flex-col gap-2">
        <router-link
          to="/guide"
          class="flex items-center gap-2 px-4 py-3 hover:bg-psychology-primary-10 rounded-lg transition-colors"
          @click="toggleMenu"
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M12 7v14"></path>
            <path d="M3 18a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h5a4 4 0 0 1 4 4 4 4 0 0 1 4-4h5a1 1 0 0 1 1 1v13a1 1 0 0 1-1 1h-6a3 3 0 0 0-3 3 3 3 0 0 0-3-3z"></path>
          </svg>
          <span class="text-sm font-medium">使用指南</span>
        </router-link>
        
        <router-link
          to="/history"
          class="flex items-center gap-2 px-4 py-3 hover:bg-psychology-primary-10 rounded-lg transition-colors"
          @click="toggleMenu"
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8"></path>
            <path d="M3 3v5h5"></path>
            <path d="M12 7v5l4 2"></path>
          </svg>
          <span class="text-sm font-medium">历史记录</span>
        </router-link>

        <router-link
          to="/assessment/start"
          class="mt-2 px-4 py-3 bg-gradient-to-r from-psychology-primary to-psychology-secondary text-white rounded-lg font-medium text-center"
          @click="toggleMenu"
        >
          开始测试
        </router-link>
      </div>
    </div>
  </nav>
</template>

<script>
export default {
  name: 'NavBar',
  data() {
    return {
      isMenuOpen: false
    }
  },
  methods: {
    toggleMenu() {
      this.isMenuOpen = !this.isMenuOpen
    }
  }
}
</script>
